
import React from 'react';
import PropTypes from 'prop-types';
import remove from 'lodash-es/remove';
import t from './utils/i18n.js';

class Filter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            selected: [],
            title: props.title
        };
    }
    render() {
        const filter = (event) => {
            const target = event.target;
            let states = this.state.selected;

            const inState = states.includes(target.value);
            if (target.checked && !inState) {

                if (this.props.trackingCategory && this.props.trackingAction) {
                    let nOptions = this.props.options.length;
                    let optionName = '';

                    for (let i=0; i<nOptions; i++) {
                        if (this.props.options[i].key === target.value) {
                            optionName = this.props.options[i].name;
                            break;
                        }
                    }

                    if (optionName) {
                        FHS.track(this.props.trackingCategory, 'filter_' + this.props.trackingAction, optionName);
                    }
                }

                states.push(target.value);
            }
            else if (!target.checked && inState) {
                remove(states, (el) => {
                    return el === target.value;
                });
            }
            let sortStates = Array.from(states);
            this.props.sort(sortStates, this.props.type);
            this.state.selected = sortStates;
        };

        this.handleClick = this.toggleFilter.bind(this);
        this.handleHide = this.hideFilter.bind(this);

        const applyFilter = () => {
            this.setState({
                active: false
            });
        };

        const resetFilter = () => {
            this.setState((previousState) => {
                previousState.selected = [];
            });
            this.props.sort([], this.props.type);
        };

        let buttonTitle = t(this.props.title, this.props.lang);

        if (this.state.selected && this.state.selected.length) {
            let valueMap = {};
            this.props.options.map((item) => {
                valueMap[item.key] = item.name;
            });
            if (this.state.selected.length === 1) {
                buttonTitle += ' • ' + t(valueMap[this.state.selected[0]], this.props.lang);
            }
            else {
                buttonTitle += ' • ' + this.state.selected.length + t(" valgt", this.props.lang);
            }
        }

        return (
            <div className="filter__wrapper">
                <button className={ 'filter__toggle filter__toggle--' + this.props.type + (this.state.active || (this.state.selected.length) ? ' filter__toggle--active' : '')} onClick={this.handleClick} name="filter-toggle">{ buttonTitle }</button>
                <div className={ 'filter__container filter__container--' + this.props.type + (this.state.active ? ' filter__container--active' : '') }>
                    <div className={ 'filter filter--' + this.props.type + (this.state.active ? ' filter__active' : '') }>
                        <div className="filter__options">
                            {this.props.options.map((item, index) =>
                                <div className="filter__type" key={this.props.type + '-' + item.key}>
                                    <label className="filter__item"><div className="checkbox"><input type="checkbox" value={item.key} onChange={filter} checked={(this.state.selected.includes(item.key)) ? 'checked' : ''} name="filter-select" /><div className="checkbox__indicator"></div></div><span className={'filter__name' + (item.description ? ' filter__name--has-description' : '')}>{t(item.name, this.props.lang)}</span></label>
                                    <div className="filter__description">{item.description ? t(item.description, this.props.lang) : ''}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    toggleFilter() {
        this.setState({
            active: !this.state.active
        });
    }
    hideFilter() {
        this.setState({
            active: false
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.checked) {
            this.state.selected = this.props.checked;
        }
    }
};

Filter.propTypes = {
    title: PropTypes.string,
    options: PropTypes.array,
    checked: PropTypes.any,
    sort: PropTypes.func,
    type: PropTypes.string,
    trackingCategory: PropTypes.string,
    trackingAction: PropTypes.string,
    lineCount: PropTypes.number,
    itemName: PropTypes.string,
    lang: PropTypes.string
};

export default Filter;
